import { useEffect, useState } from "react";

import ModalHome from "../pages/components/ModalHome";

export default function ModalTimer() {

    const [openModalHome, setOpenModalHome] = useState(false);

    useEffect(() => {

        // evita abrir mais de uma vez
        const jaAbriu = sessionStorage.getItem("modal-contblack");

        if (jaAbriu) return;

        const timer = setTimeout(() => {

            setOpenModalHome(true);

            sessionStorage.setItem("modal-contblack", "true");

        }, 45000); // 45 segundos

        return () => clearTimeout(timer);

    }, []);

    return (
        <ModalHome
            openModalHome={openModalHome}
            setOpenModalHome={setOpenModalHome}
        />
    );
}